import { render } from "./messagePush.vue?vue&type=template&id=39c36345&scoped=true"
import script from "./messagePush.vue?vue&type=script&lang=js"
export * from "./messagePush.vue?vue&type=script&lang=js"

import "./messagePush.vue?vue&type=style&index=0&id=39c36345&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c36345"]])

export default __exports__